import { setupInterceptors } from "../../../../auth/SetupInterceptors";

setupInterceptors();
export const runAction = (type) => {
  return {
    type: type,
  };
};
export const runCustomAction = (customAction) => {};
